export default "__VITE_ASSET__CmaUgMsO__"